import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const unreadActivitiesBaseUrl = `${BASE_PATH_API}/unreadActivities`;
const unreadActivitiesV2BaseUrl = `${BASE_PATH_API}/v2/unreadActivities`;

const actions = {
    get: {
        method: 'HEAD',
        url: unreadActivitiesBaseUrl,
        transformResponse: function transformResponse(response, headers) {
            return { 
                LastSeenActivityTime: headers.get('LastSeenActivityTime'),
                UnreadCount: parseInt(headers.get('X-Total-Count'), 10),
            };
        }
    },
    markActivityAsReadUnreadV2: {
        method: 'PUT',
        url: unreadActivitiesV2BaseUrl
    },
    markAllActivityAsReadV2: {
        method: 'DELETE',
        url: unreadActivitiesV2BaseUrl
    },
    logActivity: {
        method: 'PUT',
        url: unreadActivitiesBaseUrl
    },
    getUnreadActivitiesV2Count: {
        method: 'HEAD',
        url: unreadActivitiesV2BaseUrl,
        transformResponse: function transformResponse(response, headers) {
            return { 
                UnreadCount: parseInt(headers.get('X-Total-Count'), 10)
            };
        }
    }
};

export function UnreadActivitiesApi() {
    return createActions(actions);
}
